module.exports = __webpack_public_path__ + "media/images/flags/16/Guatemala-c397f5f925ef3ad0c11178ba1f0b9aa2.png";